@if (show_navbar) {
  <app-navbar></app-navbar>
}
<app-toast aria-live="polite" aria-atomic="true"></app-toast>
<router-outlet></router-outlet>
@if (show_footer) {
  <app-footer class="footer fixed-bottom"></app-footer>
}
